import {TipProcessResponse} from "./paymentApi";

export function handlePaymentProcess(response: TipProcessResponse) {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set("outcome", response.outcome);
    window.location.href = newUrl.href;
    if (!response.actionsEndpoint) {
        return;
    }
    const method = response.actionsEndpoint.method || "GET";

    const form = document.createElement("form");
    if (method === "POST") {
        form.setAttribute("enc", "application/x-www-form-urlencoded");
    }
    form.setAttribute("method", method);
    form.setAttribute("action", response.actionsEndpoint.url);

    let vars = response.actionsEndpoint.vars;
    for (const key in vars) {
        if (vars.hasOwnProperty(key)) {
            const hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", key);
            hiddenField.setAttribute("value", vars[key]);

            form.appendChild(hiddenField);
        }
    }

    document.body.appendChild(form);
    form.submit();
}

export function getBrowserData() {
    return {
        language: window.navigator.language,
        colorDepth: window.screen.colorDepth,
        screenHeight: window.screen.height,
        screenWidth: window.screen.width,
        timezone: new Date().getTimezoneOffset(),
        javaEnabled: navigator.javaEnabled(),
    };
}
